// src/constants.js

// Based on: RecordType = Literal["call", "email", "slack"]
export const RECORD_TYPES = ["call", "email", "slack"];

// UNIFIED STATUS OPTIONS
export const UNIFIED_STATUS_OPTIONS = ["open", "on hold", "completed", "cancelled"];


// Based on: GoalStatus = Literal["active", "achieved"]
// Added "on hold", "cancelled" as they are common and were in previous examples.
// Adjust if these are not actually used for Goals.
export const GOAL_STATUS_OPTIONS = UNIFIED_STATUS_OPTIONS;

// Based on: InitiativeStatus = Literal["planning", "ongoing", "completed", "blocked", "cancelled"]
// Added "on hold"
export const INITIATIVE_STATUS_OPTIONS = UNIFIED_STATUS_OPTIONS;

// Based on: ActionItemStatus = Literal["pending", "unresolved", "resolved"]
// "unresolved" might be an older status for "pending".
// Added "completed", "cancelled", "blocked" as these are common for action items.
export const ACTION_ITEM_STATUS_OPTIONS = UNIFIED_STATUS_OPTIONS;

// Based on: IssueStatus = Literal["open", "investigating", "resolved"]
// Added "cancelled"
export const ISSUE_STATUS_OPTIONS = UNIFIED_STATUS_OPTIONS;

// Based on: IssueSeverity = Literal["low", "medium", "high"]
export const ISSUE_SEVERITY_OPTIONS = ["low", "medium", "high"];

// Generic/fallback status options if needed, but prefer specific ones
export const GENERIC_STATUS_OPTIONS = ["open", "on hold", "completed", "cancelled"];

export const DRI_EXPLANATION = (
    <div>
        <p className="font-semibold text-white mb-1">DRI Calculation</p>
        <p className="mb-2 text-xs">The Directly Responsible Individual (DRI) is inferred automatically using a scoring system based on project activity:</p>
        <ul className="list-disc pl-4 text-xs space-y-1">
            <li><strong className="font-semibold">Action Items:</strong> The DRI is the person in the `assigned_to` field.</li>
            <li>
                <strong className="font-semibold">Goals, Initiatives & Issues:</strong>
                The DRI is calculated by assigning points to individuals based on their involvement:
                <ul className="list-disc pl-5 mt-1">
                    <li><strong>+2 points</strong> for each Action Item they are assigned to that is linked to the entity.</li>
                    <li><strong>+1 point</strong> for each Communication where they are the primary staff and which is linked to the entity.</li>
                </ul>
            </li>
            <li className="mt-1">The person with the highest total score is assigned as the DRI.</li>
            <li>If an item is directly assigned (e.g., on an Issue), that assignment takes precedence.</li>
        </ul>
    </div>
);